// Lets the request layer ask for the authenticator code during sign-in.
// <MfaPromptHost /> (mounted once in App.tsx) shows the popup.
export type MfaPromptOptions = { error?: string };
type Handler = (options: MfaPromptOptions) => Promise<string | null>;

let handler: Handler | null = null;

export const setMfaPromptHandler = (next: Handler | null) => {
  handler = next;
};

export const askForMfaCode = (options: MfaPromptOptions = {}): Promise<string | null> =>
  handler ? handler(options) : Promise.resolve(null);
